import { useWorkspace } from '~/stores/workspace'

export default defineNuxtRouteMiddleware(async (from, to) => {
  const { $groundcover } = useNuxtApp()

  if (!import.meta.client) {
    return
  }

  const workspace = useWorkspace()

  if (
    !hasWorkspacePermission(workspace.userPermissions, workspace.workspaceId, [
      WORKSPACE_PERMISSION.writeSystem,
      WORKSPACE_PERMISSION.readSystem,
    ])
  ) {
    $groundcover?.sendCustomEvent({
      event: 'Access system admin - DENIED',
      attributes: {
        workspace_id: workspace.workspaceId,
        workspace_name: workspace.activeWorkspace?.name,
      },
    })

    if (from.name === to.name) {
      return navigateTo({ path: '/', query: to.query }, { replace: true })
    }

    return abortNavigation()
  }
})
